<template>
  <div id="Launch" @click="enterHome">
    <template v-if="ds_id || channel_id">
      <div class="img" :style="'background-image:url(' + imgScr + ')'"></div>
      <span class="timeDown" v-if="currentCount > 0"
        >{{ currentCount }} 秒进入</span
      >
    </template>
    <p>获取房间号失败，请检查链接</p>
  </div>
</template>
<script>
import tool from "../../kits/Tools.js";
import Vue from "vue";
import { Toast} from "vant";
export default {
  data() {
    return {
      currentCount: 3,
      timer: "",
      imgScr: "",
      ds_id: "",
	  channel_id: '',
      timer2: "",
    };
  },
  props: ["loaded"],
  async mounted() {
    var that = this;

    this.ds_id = tool.getQueryDsId();
	this.channel_id = tool.getQueryChannelId();

	try {
		if(!this.ds_id && this.channel_id){
      const data =  await this.axios.post(tool.baseUrl1() + "/customer/channel/getDsIdByChannelId",'channel_code=' + this.channel_id,{timeout:6000})
        if(data.data.code == 200){
				this.ds_id = data.data.data.ds_id;
				tool.setDs_id(this.ds_id);
		  	}else{
          Toast({message:data.data.message, duration:0})
          return
        }
		}
	} catch (error) {
    try{
      const data =  await this.axios.get(tool.tencentOssUrl() + "/ds/channel_cache/channel_"+this.channel_id+".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), {timeout:2000})
      if(data){
				this.ds_id = data.data.ds_id;
				tool.setDs_id(this.ds_id);
			}
    }catch(e){
      try{
        const data =  await this.axios.get(tool.aliOssUrl() + "/ds/channel_cache/channel_"+this.channel_id+".json?" + new Date().getTime() + parseInt(Math.random() * 10e4), {timeout:1000})
        if(data){
          this.ds_id = data.data.ds_id;
          tool.setDs_id(this.ds_id);
        }
      }catch(e){
        Toast({message:'网络存在问题,请刷新重试', duration:0})
      }
    }
	}

	if(this.ds_id){
		tool.setDs_id(this.ds_id);
	}

    this.imgScr = tool.baseUrl1() + "/wap/index/dsImg/?ds_id=" + this.ds_id;
    this.timer = setInterval(function() {
      if (that.currentCount == 1) {
        clearInterval(that.timer);
        if (that.loaded) {
          that.enterHome();
        }
        that.timer2 = setInterval(function() {
          that.enterHome();
        }, 300);
      } else {
        that.currentCount -= 1;
      }
    }, 1000);
  },
  methods: {
    enterHome() {
      if (this.loaded) {
        this.$emit("closeload");
        clearInterval(this.timer1);
        clearInterval(this.timer2);
        return false;
      }
    },
  },
};
</script>

<style scoped>
#Launch {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 11000;
  background: #f5f5f5;
  top: 0;
  left: 0;
}

.img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
}

.timeDown {
  position: absolute;
  right: 15px;
  top: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 12px;
  color: white;
}

p {
  padding: 100px 0;
  text-align: center;
  font-size: 18px;
}
</style>
